var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckGreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00033 0.667236C4.40033 0.667236 0.666992 4.40057 0.666992 9.00057C0.666992 13.6006 4.40033 17.3339 9.00033 17.3339C13.6003 17.3339 17.3337 13.6006 17.3337 9.00057C17.3337 4.40057 13.6003 0.667236 9.00033 0.667236ZM7.33366 13.1672L3.16699 9.00057L4.34199 7.82557L7.33366 10.8089L13.6587 4.4839L14.8337 5.66724L7.33366 13.1672Z",
    fill: "#2DB875"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGreenIcon);
export default __webpack_public_path__ + "static/media/check-green_icon.bde2c567e0f00593154fd1d866721e7a.svg";
export { ForwardRef as ReactComponent };